var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CabeceraTabla", {
        attrs: { permisoAccion: _vm.accionCrear },
        scopedSlots: _vm._u([
          {
            key: "izquierda",
            fn: function() {
              return [
                _c("BuscadorMantenedor", {
                  attrs: { filter: _vm.handleBusqueda }
                })
              ]
            },
            proxy: true
          },
          {
            key: "centro",
            fn: function() {
              return [
                _c("ExportarAgGridButton", {
                  attrs: {
                    permisoAccion: _vm.accionExportar,
                    "column-defs": _vm.gridOptions.columnDefs,
                    "row-data": _vm.lstProgramacionesInformes,
                    "exported-file-name": "ProgramacionDeInformes"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "derecha",
            fn: function() {
              return [
                _c("CrearButton", {
                  attrs: { permisoAccion: _vm.accionCrear },
                  on: {
                    click: function($event) {
                      return _vm.handleCrearClick()
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("MantenedorGridTodos", {
        attrs: {
          "grid-options": _vm.gridOptions,
          rowData: _vm.lstProgramacionesInformes,
          "funcionalidad-id": _vm.funcionalidad
        }
      }),
      _vm.isModalCrearActivo
        ? _c("CrearProgramacionInformeModal", {
            on: { cerrar: _vm.cerrarModalCrud, crear: _vm.handleCrearOrEditar }
          })
        : _vm._e(),
      _vm.isModalEditarActivo
        ? _c("EditarProgramacionInformesModal", {
            attrs: {
              informeProgramadoSeleccionado: _vm.informeProgramadoSeleccionado,
              notificacion: _vm.notificacion
            },
            on: { cerrar: _vm.cerrarModalCrud, crear: _vm.handleCrearOrEditar }
          })
        : _vm._e(),
      _vm.isModalVerDetalleActivo
        ? _c("VerProgramacionInformeModal", {
            attrs: {
              informeProgramadoSeleccionado: _vm.informeProgramadoSeleccionado,
              notificacion: _vm.notificacion
            },
            on: { cerrar: _vm.cerrarModalCrud }
          })
        : _vm._e(),
      _c("ConfirmacionEliminar", {
        attrs: {
          show: _vm.isConfirmacionEliminarActivo,
          titulo: _vm.tituloConfirmacionEliminar,
          mensaje: _vm.$t("mensajes.crud.eliminar.mensaje", {
            entidad: "la Programacion de Informes"
          })
        },
        on: {
          aceptar: _vm.handleConfirmacionEliminar,
          cancelar: _vm.cerrarModalCrud
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }